define("shared/models/ig-story", ["exports", "@ember/object"], function (_exports, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/object"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  class IgStory extends _object.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "caption", null);
      _defineProperty(this, "createdTime", null);
      _defineProperty(this, "exits", null);
      _defineProperty(this, "id", null);
      _defineProperty(this, "imageUrl", null);
      _defineProperty(this, "impressions", null);
      _defineProperty(this, "views", null);
      _defineProperty(this, "mediaUrl", null);
      _defineProperty(this, "reach", null);
      _defineProperty(this, "replies", null);
      _defineProperty(this, "socialProfile", null);
      _defineProperty(this, "tapsBack", null);
      _defineProperty(this, "tapsForward", null);
      _defineProperty(this, "thumbnailUrl", null);
      _defineProperty(this, "timeCollected", null);
      _defineProperty(this, "imageMediumUrl", null);
      _defineProperty(this, "type", null);
    }
  }
  _exports.default = IgStory;
});